import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BookOpen, Download, Eye, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function LojistaRegimento() {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let ativa = true;
    (async () => {
      try {
        const resp = await api.get("/regimento/pdf", { responseType: "blob" });
        if (!ativa) return;
        const url = URL.createObjectURL(new Blob([resp.data], { type: "application/pdf" }));
        setPdfUrl(url);
      } catch {
        toast.error("Não foi possível carregar o regimento");
      } finally {
        setLoading(false);
      }
    })();
    return () => {
      ativa = false;
      if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    };
    // eslint-disable-next-line
  }, []);

  const baixar = async () => {
    try {
      const resp = await api.get("/regimento/download", { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([resp.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = "regimento-interno-vm-piabeta.pdf";
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Download iniciado");
    } catch {
      toast.error("Falha no download");
    }
  };

  return (
    <div className="space-y-4 fade-up">
      <div>
        <div className="label-tag mb-2">Documento oficial · VM Piabetá Shopping</div>
        <h1 className="font-heading font-black tracking-tighter text-3xl break-anywhere">Regimento Interno</h1>
      </div>

      <Card className="p-5 rounded-2xl border-border">
        <div className="flex items-center gap-3 mb-4">
          <BookOpen size={18} className="text-foreground" />
          <div>
            <div className="font-heading font-bold">Leia atentamente as regras</div>
            <div className="text-xs text-muted-foreground">Este documento faz parte do seu contrato de locação.</div>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-2">
          <a
            data-testid="regimento-abrir"
            href={pdfUrl || "#"}
            target="_blank"
            rel="noreferrer"
            onClick={(e) => { if (!pdfUrl) e.preventDefault(); }}
            className={`inline-flex items-center justify-center gap-2 rounded-xl h-12 text-sm font-semibold border border-input bg-background hover:bg-accent transition-colors ${!pdfUrl ? "opacity-50 pointer-events-none" : ""}`}
          >
            <Eye size={14} /> Abrir
          </a>
          <Button data-testid="regimento-download" onClick={baixar} className="rounded-xl h-12 bg-foreground text-background hover:bg-foreground/90">
            <Download size={14} className="mr-2" /> Baixar PDF
          </Button>
        </div>
      </Card>

      <Card className="p-2 rounded-2xl border-border overflow-hidden">
        <div className="label-tag px-4 pt-2 pb-1">Pré-visualização</div>
        {loading ? (
          <div className="h-96 flex items-center justify-center text-muted-foreground text-sm">
            <Loader2 size={20} className="animate-spin mr-2" /> Carregando regimento...
          </div>
        ) : pdfUrl ? (
          <iframe
            data-testid="regimento-iframe"
            src={pdfUrl}
            className="w-full h-[500px] border-0 rounded-xl"
            title="Regimento Interno"
          />
        ) : (
          <div className="h-40 flex items-center justify-center text-destructive text-sm">
            Falha ao carregar o PDF.
          </div>
        )}
      </Card>
    </div>
  );
}
